import { useAppDispatch } from "../../../app/hooks";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/userSlice";
import { useEffect, useState } from "react";
import { MassiveMessage, massiveMessageSlice, retrieveMassiveMessages, selectMassiveMessage } from "../../../redux/conversation/massive/massiveMessageSlice";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import MassiveMessageRow from "./MassiveMessageRow";
import PrizaContainer from "../../../features/base/grid/PrizaContainer";
import MassiveMessageDetail from "./MassiveMessageDetail";

interface MassiveMessageProps {
    schoolId: string;
}

const MassiveMessageReport = ({ schoolId }: MassiveMessageProps) => {
    const dispatch = useAppDispatch();
    // const navigate = useNavigate();
    const user = useSelector(selectUser);
    const massiveMessage = useSelector(selectMassiveMessage);
    // const massiveMessageUser = useSelector(selectMassiveMessageUser);
    // const messageDismissed = useSelector(selectMessageDismissed);

    const [selectedMassiveMessage, setSelectedMassiveMessage] = useState<MassiveMessage | null>(null);

    useEffect(() => {
        if (massiveMessage.request?.schoolId && `${massiveMessage.request?.schoolId}` != schoolId) {
            dispatch(massiveMessageSlice.actions.clean());
        }
        dispatch(retrieveMassiveMessages({ schoolId: parseInt(schoolId) }));
    }, [massiveMessage, schoolId, user]);


    const list = massiveMessage.list || [];

    // const buttons = hasPermission(user.priza.info, PermissionId.SCHOOL_ADMIN, schoolId) ? [
    //     {
    //         label: <AddIcon />,
    //         click: () => {
    //             dispatch(classroomSlice.actions.clean());
    //             navigate(routeDptoNew(schoolId));
    //         }
    //     }
    // ] : undefined;

    const open = (row: MassiveMessage) => {
        setSelectedMassiveMessage(row);
    };

    const close = () => {
        setSelectedMassiveMessage(null);
    };

    if (selectedMassiveMessage) {
        return <MassiveMessageDetail selected={selectedMassiveMessage} onClose={close} />;
    }

    const content = () => {
        return <TableContainer component={Paper} sx={{ m: 1 }}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        {/* <TableCell align="left">Escola</TableCell> */}
                        {/* <TableCell align="left">Sala de aula</TableCell> */}
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                            }}>Tipo de Alvo</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                            }}>Alvo</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                            }}>Prioridade</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                            }}>Data</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                            }}>Responsável</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {list.map((row) => (
                        <MassiveMessageRow key={row.id} row={row} open={open}/>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>;
    };

    return <PrizaContainer
        state={massiveMessage.state}
        toolbar={{
            label: "Mensagens Massivas"
        }}
        messages={{
            empty: "Nenhuma mensagem massiva encontrada.",
            error: "Erro ao carregar mensagens massivas."
        }}
        content={content}
        retry={() => { dispatch(massiveMessageSlice.actions.clean()); }}
    />;

};

export default MassiveMessageReport;